import { createStore } from 'vuex'

export default createStore({
  state: {
    language:"cn",
    isPc: false
  },
  getters: {
  },
  mutations: {
     changeLanguage(state,string){
      this.state.language = string;
    },

    changePcOrPhone(state,bool){
      this.state.isPc = bool;
    }
  },
  actions: {
  },
  modules: {
  }
})
